import React, { FC, useMemo } from 'react';
import { SafeHtml, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { StyledNeedHelpButton, StyledNeedHelpModal, StyledBusinessHours, StyledPhoneNumber, StyledDiv } from './NeedHelpModal.styles';
import { NeedHelpHoursInfo } from '../NeedHelpHoursResource/NeedHelpHoursResource';
import { NeedHelpPhoneInfo } from '../NeedHelpPhoneResource/NeedHelpPhoneResource';
import { getContentFieldValue } from './getContentFieldValue';
import { ContentItem } from '../../../interfaces/ContentItem';

export interface NeedHelpModalProps { }

const NeedHelpModal: FC<NeedHelpModalProps> = () => {
  const { t } = useTranslation('NeedHelp');
  const needHelpPhone: ContentItem = useScopedSelector(NeedHelpPhoneInfo.dataDst);
  const needHelpHours: ContentItem = useScopedSelector(NeedHelpHoursInfo.dataDst);

  const description = useMemo(() => (getContentFieldValue(needHelpPhone, 'Description')), [needHelpPhone]);
  const title = useMemo(() => (getContentFieldValue(needHelpPhone, 'Title')), [needHelpPhone]);
  const businessHours = useMemo(() => (getContentFieldValue(needHelpHours, 'Description')), [needHelpHours]);
  if (!needHelpPhone || !needHelpHours) return null;
  return (
    <>
      <StyledNeedHelpModal name="needHelp" headerBackground="transparent">
        <StyledDiv>
          <SafeHtml>{title}</SafeHtml>
        </StyledDiv>
        <StyledBusinessHours addTags={['img']} addAttr={['src']}>{businessHours}</StyledBusinessHours>
        <div>
          <StyledPhoneNumber addTags={['img']} addAttr={['src']}>{description}</StyledPhoneNumber>
        </div>
      </StyledNeedHelpModal>
      <StyledNeedHelpButton outline onClickAction="needHelp.openModal" data-testid="NeedHelp">
        {t('needHelp')}
      </StyledNeedHelpButton>
    </>
  );
};

export default NeedHelpModal;
